import React, { useEffect } from 'react';
import { z } from 'zod';
import InputField from '../../core/Input/TextInput/InputField';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import Button from '../../core/Button/Button';

const schema = z.object({
  title: z.string().min(2, 'عنوان زیردسته‌ نمی تواند کمتر از دو حرف باشد'),
});

type FormData = z.infer<typeof schema>;

type subCategoryFormProps = {
  defaultValues?: FormData;
  onSubmit: (data: FormData) => Promise<void>;
  isSubmitting: boolean;
  formTitle: string;
  buttonTitle: string;
};

const CategoryForm: React.FC<subCategoryFormProps> = ({
  defaultValues,
  onSubmit,
  isSubmitting,
  formTitle,
  buttonTitle,
}) => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(schema),
    defaultValues,
  });

  useEffect(() => {
    if (defaultValues) {
      reset(defaultValues);
    }
  }, [defaultValues, reset]);

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className="container mx-auto mt-[10%] p-4 rounded-lg w-6/12 bg-white text-black"
    >
      <h1 className="text-right font-bold text-sm md:text-lg lg:text-2xl">
        {formTitle}
      </h1>
      <InputField
        containerClassName="text-start py-2"
        label="عنوان زیردسته"
        type="text"
        placeholder="سیفون"
        error={errors.title?.message}
        {...register('title')}
      />
      <Button>{isSubmitting ? 'درحال ارسال...' : buttonTitle}</Button>
    </form>
  );
};

export default CategoryForm;
